import MinusCircleFill from './MinusCircleFill';

export default MinusCircleFill;
